import React from "react";
import { addDays, endOfMonth, endOfWeek, format, isSameDay, isSameMonth, startOfMonth, startOfWeek } from "date-fns";
import { ListTodo } from "lucide-react";
import { EventPill } from "@/components/nds/windows/sch/parts";

export const monthRange = (d) => [startOfWeek(startOfMonth(d)), addDays(endOfWeek(endOfMonth(d)), 1)];

export default function MonthView({ anchor, events, tasks, onOpen, onPickDay }) {
  const [start, end] = monthRange(anchor);
  const days = [];
  for (let d = start; d < end; d = addDays(d, 1)) days.push(d);
  const today = new Date();
  return (
    <div data-testid="sch-month" className="grid grid-cols-7 flex-1 min-h-0 border-l border-t border-white/10" style={{ gridTemplateRows: `auto repeat(${Math.ceil(days.length / 7)}, minmax(0, 1fr))` }}>
      {["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"].map((d) => (
        <div key={d} className="border-r border-b border-white/10 px-2 py-1 font-mono text-[10px] tracking-[0.2em] uppercase text-nex-muted">{d}</div>
      ))}
      {days.map((d) => {
        const list = events.filter((e) => isSameDay(new Date(e.start_time), d));
        const dayTasks = (tasks?.tasks || []).filter((t) => t.date === format(d, "yyyy-MM-dd"));
        const open = dayTasks.filter((t) => t.status === "open").length;
        return (
          <div key={d.toISOString()} onClick={() => onPickDay(d)} data-testid={`sch-month-day-${format(d, "yyyy-MM-dd")}`}
            className={`border-r border-b border-white/10 p-1 min-h-[92px] cursor-pointer hover:bg-white/[0.02] ${isSameMonth(d, anchor) ? "" : "opacity-40"}`}>
            <div className={`text-[11px] mb-1 w-6 h-6 grid place-items-center rounded-full ${isSameDay(d, today) ? "bg-nex-gold text-black font-bold" : "text-nex-silver"}`}>{format(d, "d")}</div>
            <div className="space-y-0.5">
              {dayTasks.length > 0 && (
                <div data-testid={`sch-month-tasks-${format(d, "yyyy-MM-dd")}`} className={`inline-flex items-center gap-1 text-[10px] font-mono px-1 ${open ? "text-nex-gold" : "text-emerald-300"}`}>
                  <ListTodo className="h-3 w-3" /> {dayTasks.length - open}/{dayTasks.length} tasks done
                </div>
              )}
              {list.slice(0, 3).map((e) => <EventPill key={e.id} ev={e} onOpen={onOpen} />)}
              {list.length > 3 && <div className="text-[10px] text-nex-muted px-1">+{list.length - 3} more</div>}
            </div>
          </div>
        );
      })}
    </div>
  );
}
